import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Search from './Search';
import SearchOptions from './SearchOptions.js';
import './SearchHero.css';
import './SearchOptions.css';

class SearchHero extends Component {

	/*
	componentWillMount() {		   
    	document.body.className = 'SearchHeroBackground';
	}
	componentWillUnmount() {
    	document.body.className = null;
	}*/

	renderHeader() {
		return (
			<div className="SearchHeroHeader">
				<h1 style={{fontWeight: '600'}}>WEB SOURCE CODE</h1>
				<h2>
					HTML <span className="star">&#9900;</span> JavaScript <span className="star">&#9900;</span> Headers <span className="star">&#9900;</span> SEO <span className="star">&#9900;</span> TEXT
				</h2>				
			</div>
		)
	}

  render() {

	const searchForm = 
		<Search bsSize="lg" userQuery={this.props.userQuery} handleQueryChange={this.props.handleQueryChange} handleSubmit={this.props.handleSubmit} loading={this.props.loading} options={this.props.options} handleOptionsClick={this.props.handleOptionsClick}/>

	const searchOptions = (
		<div className="SearchOptionsContainer">
			<SearchOptions visible={this.props.optionsVisible} options={this.props.options} handleOptionsChange={this.props.handleOptionsChange} handleOptionHover={this.props.handleOptionHover} explainerMessage={this.props.explainerMessage}/>
		</div>
	)

	const subheader = <h3>Search the source code of the web</h3>

	let optionalStyle = this.props.searchPristine ? {} : { backgroundImage: 'none' };

    return (


      	<div className="SearchHero" style={optionalStyle}>
					
			<Grid>
				<Row>
					<Col md={12}>
						<div className="text-center">
							
							{this.props.searchPristine && this.renderHeader()}
							
							{ searchForm }
							{ searchOptions }

							{this.props.searchPristine && subheader}

						</div>
					</Col>
				</Row>
				<Row>
					<Col md={12} className="text-center">

					</Col>
				</Row>
			</Grid>

		</div>
	);
  }
}

export default SearchHero;



// WEBPACK FOOTER //
// ./src/SearchHero.js